import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, CircularProgress, IconButton, Switch, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { useSelector } from "react-redux";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../../offline/db";
import {
  AddHomeWork,
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import FailureCodeModal from "./ServiceReqModal";
import ServiceReqModal from "./ServiceReqModal";
import { toast } from "react-toastify";
import FeedBack from "../../../Component/FeedBack";
import SRView from "./SRView";
import StatusCheckboxFilter from "../../../Component/StatusCheckboxFilter";
import { decode, encode } from "../../../Component/JWT/Formatt";
import { SubMenu } from "../../../ConfigInfo/Info";

import ResponsiveDialog from "../../../Component/ResponsiveDialog";
const ServiceReq = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);
  const menuArray = useSelector((state) => state.dataRed.menuArray);
  const canGenerate =
    Array.isArray(menuArray) &&
    menuArray.filter((item) => item.id === SubMenu.workorder)[0]?.create ===
      true;
  const [statusList, setStatusList] = useState([]);
  const [selectSR, setSelectSR] = useState("");
  const [feedBack, setFeedBack] = useState(false);

  const [statusMenuDetail, setStatusDetail] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [SRID, setSRID] = useState("");
  const [view, setView] = useState(false);
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);
  const [approvalContext, setApprovalContext] = useState(null);
  const [offlineCachedAt, setOfflineCachedAt] = useState(null);
  const [generateLoadingId, setGenerateLoadingId] = useState(null);

  const pendingSR = useLiveQuery(
    () => db.writeQueue.where({ entityType: "serviceRequest" }).toArray(),
    [],
    [],
  );

  const displayData = useMemo(() => {
    const pendingRows = (pendingSR || [])
      .filter((item) => item.displayRow)
      .map((item) => ({ ...item.displayRow, id: item.tempId, _pendingSync: true }));
    return [...pendingRows, ...data];
  }, [data, pendingSR]);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const handleSynced = (event) => {
      if (event.detail?.entityType === "serviceRequest") {
        getData();
      }
    };
    window.addEventListener("offlineSyncSuccess", handleSynced);
    return () => window.removeEventListener("offlineSyncSuccess", handleSynced);
  }, []);

  // Handle opening modal when id parameter is present in URL
  useEffect(() => {
    const idParam = searchParams.get("id");
    const fromApproval = searchParams.get("fromApproval");
    const approvalId = searchParams.get("approvalId");

    if (idParam && data.length > 0) {
      try {
        const decodedId = decode(idParam);
        const srData = data.find((item) => item.id === decodedId);
        if (srData) {
          // Store approval context if coming from approval page
          if (fromApproval === "true" && approvalId) {
            setApprovalContext({
              approvalId: decode(approvalId),
              fromApproval: true,
            });
            // Open SRView modal instead of edit modal when from approval
            setView(true);
            setSRID(encode(decodedId));
          } else {
            // Normal edit flow
            setEditData(srData);
            setMode("Edit");
            setCreate(true);
          }

          // Remove the parameters from URL after opening modal
          searchParams.delete("id");
          searchParams.delete("fromApproval");
          searchParams.delete("approvalId");
          setSearchParams(searchParams);
        }
      } catch (error) {
        console.log("Error decoding service request id:", error);
      }
    }
  }, [data, searchParams]);

  const getData = async () => {
    setIsLoading(true);
    const link = masterAPI["serviceRequest"].link;
    await axiosPrivate
      .get(`${link}`, { offlineCache: { entityType: "serviceRequest" } })
      .then((res) => {
        // res.data.result.sort((a, b) => {
        //   return b.code.localeCompare(a.code, undefined, {
        //     numeric: true,
        //     sensitivity: 'base'
        //   });
        // });
        setOfflineCachedAt(res.__offlineCached ? res.__cachedAt : null);
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter(
            (fil) => fil.isActive,
          );
          console.log(filterDataResult, "locationresult");
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "serviceRequest");
        setIsLoading(false);
        setData([]);
        setBackUpData([]);
      });

    const statusData = masterAPI["selectList"].serviceRequestStatus;
    await axiosPrivate
      .get(`${statusData}`)
      .then((res) => {
        console.log(res);
        const filterStatus = res.data.filter(
          (fil) => fil.text.toUpperCase() === "CANCELLED",
        );
        setStatusList(filterStatus);
      })
      .catch((e) => {
        setStatusList([]);
        console.log(e, "error");
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    setEditData({});

    // Redirect to workflow approval if coming from there
    if (approvalContext?.fromApproval) {
      navigate("/workflowapproval");
    } else {
      getData();
    }

    setApprovalContext(null);
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  const handleWO = async (val) => {
    const convertlink = masterAPI["serviceRequest"].coverttowo;
    setGenerateLoadingId(val.id);
    try {
      const response = await axiosPrivate.put(`${convertlink}/${val.id}`);
      console.log(response);
      await getData();
    } catch (e) {
      console.log(e, "sr error");
    } finally {
      setGenerateLoadingId(null);
    }
  };

  // const handleDelete = (id) => {
  //   const deleteLink = masterAPI["serviceRequest"].delete;
  //   axiosPrivate
  //     .delete(`${deleteLink}/${id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       getData();
  //     })
  //     .catch((e) => {
  //       console.log(e, "delete serviceRequest");
  //     });
  // };

  const handleDelete = async (e, id) => {
    const enableLink = masterAPI["serviceRequest"].enable;
    const disableLink = masterAPI["serviceRequest"].disable;
    if (e.target.checked) {
      await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "enable sr");
        });
    } else {
      await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "disable sr");
        });
    }
  };

  const handleCheckList = (e, v) => {
    //  if(e.target.checked){
    //   setSelectSR([...selectSR,v])
    //  }else{
    //   const filterSR=selectSR.filter(fil=>fil!==v)
    //   setSelectSR(filterSR)
    //  }
    if (e.target.checked) {
      setSelectSR(v);
    } else {
      setSelectSR("");
    }
  };

  const handleView = (id) => {
    setView(true);
    setSRID(encode(id));
  };

  const handleCloseView = () => {
    setView(false);
    setSRID("");

    // Redirect to workflow approval if coming from there
    if (approvalContext?.fromApproval) {
      navigate("/workflowapproval");
    } else {
      getData();
    }

    setApprovalContext(null);
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox
              disabled={cell.row.original.status.toUpperCase() === "CANCELLED"}
              // icon={<RadioButtonUncheckedOutlined />}
              // checkedIcon={<CheckCircle />}
              checked={selectSR.includes(cell.value)}
              onClick={(e) => {
                handleCheckList(e, cell.value);
              }}
            />
          </Box>
        );
      },
    },
    {
      Header: "Service Request Code",
      accessor: "code",
      Cell: ({ cell }) => {
        if (cell.row.original._pendingSync) {
          return (
            <Typography sx={{ fontSize: "inherit", fontWeight: "inherit", color: "#B98900" }}>
              {cell.value} (syncing…)
            </Typography>
          );
        }
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: "#0d6efd",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => handleView(cell.row.original.id)}
          >
            {cell.value}
          </Typography>
        );
      },
    },
    {
      Header: "Service Request Name",
      accessor: "serviceRequestName",
    },
    // {
    //   Header:"Description",
    //   accessor:"description"
    // },
    {
      Header: "Asset Name",
      accessor: "assetName",
    },
    {
      Header: "Loaction",
      accessor: "locationName",
    },
    // {
    //   Header: "Problem Name",
    //   accessor: "problemName",
    //   // disableFilters: true,
    // },
    // {
    //   Header: "Failure Class Name",
    //   accessor: "failureClassName",
    // },
    // {
    //   Header: "Status",
    //   accessor: "status",
    //   Filter: StatusCheckboxFilter,
    //   filter: 'includesSome',
    //   disableFilters: false,
    //   cell: ({cell}) => (
    //     <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
    //              {cell.value}
    //            </Typography>
    //   ),
    // },
    {
      Header: "Status",
      accessor: "status",
      Filter: StatusCheckboxFilter,
      filter: "includesSome",
      disableFilters: false,
      cell: ({ cell }) => (
        <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
          {cell.value}
        </Typography>
      ),
    },

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const isGenerating = generateLoadingId === cell.row.original.id;
        const canGenerateForRow =
          canGenerate &&
          ["APPR", "OPEN"].includes(cell.row.original.status.toUpperCase());
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton
              disabled={!canGenerateForRow || isGenerating}
              onClick={() => handleWO(cell.row.original)}
              title="Generate Work Order"
            >
              {isGenerating ? (
                <CircularProgress size={color.masterEditDelButton} />
              ) : (
                <AddHomeWork
                  sx={{
                    fontSize: color.masterEditDelButton,
                    color: canGenerateForRow
                      ? color.masterEditDelButtonColor
                      : "default",
                  }}
                />
              )}
            </IconButton>
            <IconButton
              onClick={() => {
                handleEdit(cell.row.original);
              }}
              disabled={
                !(
                  (cell.row.original.status.toUpperCase() === "RESUBMIT" ||
                    cell.row.original.status.toUpperCase() === "OPEN") &&
                  actionsAllow.edit
                )
              }
            >
              <EditOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    (cell.row.original.status.toUpperCase() === "RESUBMIT" ||
                      cell.row.original.status.toUpperCase() === "OPEN") &&
                    actionsAllow.edit
                      ? color.masterEditDelButtonColor
                      : "default",
                }}
              />
            </IconButton>
            {/* <IconButton
              disabled={
                cell.row.original.status.toUpperCase() !== "NEW" ||
                !actionsAllow.delete
              }
              onClick={() => {
                handleDelete(cell.row.original.id);
              }}
            >
              <DeleteOutline
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    cell.row.original.status.toUpperCase() !== "NEW" ||
                    !actionsAllow.delete
                      ? "default"
                      : color.masterEditDelButtonColor,
                }}
              />
            </IconButton> */}
            <Switch
              disabled={
                cell.row.original.status.toUpperCase() !== "OPEN" ||
                !actionsAllow.delete
              }
              checked={cell.row.original.isActive}
              onChange={(e) => {
                handleDelete(e, cell.row.original.id);
              }}
            />
          </Box>
        );
      },
    },
  ];
  const tableFilterTypes = {
    includesSome: (rows, id, filterValues) => {
      if (!filterValues || filterValues.length === 0) {
        if (id === "status") {
          return rows.filter((row) => row.values[id] !== "CLOSE");
        }
        return rows;
      }
      return rows.filter((row) => {
        const rowValue = row.values[id];
        return filterValues.includes(rowValue);
      });
    },
  };
  const handleMenuSelect = async (menuData, reason) => {
    setFeedBack(false);
    const putData = {
      id: selectSR,
      status: menuData.value,
      reasontoCancel: reason,
    };
    console.log(putData);
    const statusLink = masterAPI["serviceRequest"].updateStatus;
    await axiosPrivate
      .put(`${statusLink}`, putData)
      .then((res) => {
        console.log(res);
        setSelectSR("");
        getData();
      })
      .catch((e) => {
        console.log(e, "error");
      });
  };

  const menuStatusHandle = (menuData) => {
    console.log(menuData);
    setStatusDetail(menuData);
    // const putData=[]
    // for(let i=0;selectSR.length>i;i++){
    //   putData.push({
    //     id:selectSR[i],
    //     status:menuData.value
    //   })
    // }
    if (menuData.value === "CANCELLED") {
      setFeedBack(true);
    } else {
      handleMenuSelect(menuData, "");
    }
  };

  // const handleChangeFilter=(e)=>{

  //   if(e==="showAll"){
  //     setData(backUpData)
  //   }else{
  //       const filterDataResult=backUpData.filter(fil=>fil.isActive)

  //       setData(filterDataResult);
  //   }
  //   setFilterValue(e)
  // }

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else if (e === "enableData") {
      const filterDataResult = backUpData.filter(
        (fil) => fil.isActive,
      );
      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["serviceRequest"].title}
        </Typography>
        {offlineCachedAt && (
          <Typography sx={{ fontSize: "0.8rem", color: "#B98900", mb: "0.5rem" }}>
            Showing offline data from {new Date(offlineCachedAt).toLocaleString()} — may not be up to date.
          </Typography>
        )}
      </Box>
      <TableContainer
        columns={columns}
        data={displayData}
        buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
        statusList={statusList}
        menuStatusHandle={menuStatusHandle}
        changeStatusOption={selectSR.length !== 0}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
        filterTypes={tableFilterTypes}
        hideStatuses={["CLOSE", "CANCELLED"]}
      />

      <ResponsiveDialog
        open={create}
        onClose={handleCreateClose}
        fullWidth
        maxWidth={"md"}
        children={
          <ServiceReqModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
            approvalContext={approvalContext}
          />
        }
      />
      <ResponsiveDialog
        open={view}
        onClose={handleCloseView}
        fullWidth
        maxWidth={"lg"}
        // PaperProps={{
        //   sx: {
        //     maxWidth: '70vw',
        //     width:"65vw"
        //   },
        // }}
        children={
          <SRView
            handleCloseClick={handleCloseView}
            viewId={SRID}
            approvalContext={approvalContext}
          />
        }
      />

      <ResponsiveDialog
        open={feedBack}
        onClose={() => setFeedBack(false)}
        maxWidth={"lg"}
        children={
          <FeedBack
            handleCloseClick={(e) => handleMenuSelect(statusMenuDetail, e)}
            onCancel={() => {
              setFeedBack(false);
            }}
          />
        }
      />
    </>
  );
};

export default ServiceReq;
